import {useRef, useState, useTransition, useEffect} from 'react';
import {Button, RadioGroup, TextField, Alert} from '@bonprix/design-system';
import Url from '@core/scripts/helper/url';
import fetchWithCsrf from '../../../../../../../core/src/main/resources/scripts/helper/fetch-with-csrf.js';
import ModelContainer from "@core/scripts/components/model-container";


const model = ModelContainer.get("servicePageModel");

/**
 * @param {Object} props
 * @param {NewsletterUnsubscribeForm} props.cdaEntry
 */
export function NewsletterUnsubscribeForm({cdaEntry}) {
    const [, startTransition] = useTransition();
    const [formValues, setFormValues] = useState({
        email: '',
    });
    const [submitButtonIsDisabled, setSubmitButtonIsDisabled] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [formErrors, setFormErrors] = useState({});

    const handleChange = (name) => (value) => {
        startTransition(() => setFormValues((prev) => ({...prev, [name]: value})));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setFormErrors({});
        setErrorMsg("");
        setIsSubmitting(true);

        fetchWithCsrf(Url.toAbsolute(cdaEntry.fields.unsubscribeApiUrl), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formValues),
        }).then((response) => {
            response.json().then((data) => {
                if(data.errors){
                    setFormErrors(data.errors);
                }
                if(data.errorMsg){
                    setErrorMsg(cdaEntry.fields[data.errorMsg]);
                }

                if(data.errors || data.errorMsg){
                    fcWidget.current.reset();
                }

                //redirect to real unsubscribe page
                if(data.success){
                    window.location = Url.toAbsolute(`/newsletter/unsubscribe/`);
                }
            });
        })
        .catch((error) => {
            console.error(error);
            setErrorMsg("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.");
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    return (
        <div className="service-page-newsletter-unsubscribe-form">
            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <TextField
                        label={cdaEntry.fields.labelEmail}
                        required
                        inputMode="email"
                        type="email"
                        value={formValues.email}
                        name="email"
                        onChange={handleChange('email')}
                        error={formErrors && !!formErrors.email}
                        errorText={formErrors && formErrors.email && cdaEntry.fields[formErrors.email]}
                    />
                </div>

                {errorMsg && (
                    <div className="form-row">
                         <Alert isOpen severity="error" showCloseIcon={false}>{errorMsg}</Alert>
                    </div>
                )}

                <div className="form-row">
                    <Button type="submit" loading={isSubmitting}>
                        {cdaEntry.fields.labelButtonSubmit}
                    </Button>
                </div>
            </form>
        </div>
    )
}